import React, { FC } from 'react';

export const AfterLogoutPage: FC = () => {
  return <div>Thank you for using BitFlow</div>;
};
